import { CodeItemWire } from '../types';
import { CodeItem } from '../types-store';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

//eslint:disable max-func-body-length
export const mapCodeToStore = (codeItemWire: CodeItemWire): CodeItem => ({
  ...(!!codeItemWire.code && {
    id: codeItemWire.code.v
  }),

  ...(!!codeItemWire.validFrom && {
    validFrom: parseAsDateUTC(codeItemWire.validFrom)
  }),

  ...(!!codeItemWire.substanceCategory && {
    substanceCategory: {
      value: codeItemWire.substanceCategory.v,
      description: codeItemWire.substanceCategory.d,
      disabled: parseAsDateUTC(codeItemWire.substanceCategory.disabled)
    }
  }),

  ...(!!codeItemWire.substance && {
    substance: {
      value: codeItemWire.substance.v,
      description: codeItemWire.substance.d,
      disabled: parseAsDateUTC(codeItemWire.substance.disabled),
      ...(isDefinedIncludingZero(codeItemWire.substanceCategory?.v) && { categoryId: codeItemWire.substanceCategory.v })
    }
  }),

  ...(!!codeItemWire.substanceUom && {
    substanceUom: {
      value: codeItemWire.substanceUom.v,
      description: codeItemWire.substanceUom.d,
      disabled: parseAsDateUTC(codeItemWire.substanceUom.disabled)
    }
  }),

  ...(!!codeItemWire.indicatorSubstanceCategory && {
    indicatorSubstanceCategory: {
      value: codeItemWire.indicatorSubstanceCategory.v,
      description: codeItemWire.indicatorSubstanceCategory.d,
      disabled: parseAsDateUTC(codeItemWire.indicatorSubstanceCategory.disabled)
    }
  }),

  ...(!!codeItemWire.indicatorSubstance && {
    indicatorSubstance: {
      value: codeItemWire.indicatorSubstance.v,
      description: codeItemWire.indicatorSubstance.d,
      disabled: parseAsDateUTC(codeItemWire.indicatorSubstance.disabled),
      ...(isDefinedIncludingZero(codeItemWire.indicatorSubstanceCategory?.v) && { categoryId: codeItemWire.indicatorSubstanceCategory.v })
    }
  }),

  ...(!!codeItemWire.indicatorSubstanceUom && {
    indicatorSubstanceUom: {
      value: codeItemWire.indicatorSubstanceUom.v,
      description: codeItemWire.indicatorSubstanceUom.d,
      disabled: parseAsDateUTC(codeItemWire.indicatorSubstanceUom.disabled)
    }
  }),

  ...(!!codeItemWire.indicatorType && {
    indicatorType: {
      value: codeItemWire.indicatorType.v,
      description: codeItemWire.indicatorType.d,
      disabled: parseAsDateUTC(codeItemWire.indicatorType.disabled)
    }
  }),

  ...(!!codeItemWire.location && {
    location: {
      value: codeItemWire.location.v,
      description: codeItemWire.location.d,
      disabled: parseAsDateUTC(codeItemWire.location.disabled)
    }
  }),

  ...(!!codeItemWire.unit && {
    unit: {
      value: codeItemWire.unit.v,
      description: codeItemWire.unit.d,
      disabled: parseAsDateUTC(codeItemWire.unit.disabled)
    }
  }),

  ...(!!codeItemWire.source && {
    source: {
      value: codeItemWire.source.v,
      description: codeItemWire.source.d,
      disabled: parseAsDateUTC(codeItemWire.source.disabled)
    }
  }),

  ...(!!codeItemWire.equipment && {
    equipment: {
      value: codeItemWire.equipment.v,
      description: codeItemWire.equipment.d,
      disabled: parseAsDateUTC(codeItemWire.equipment.disabled)
    }
  }),

  ...(isDefinedIncludingZero(codeItemWire.factor) && {
    factor: codeItemWire.factor
  })
});
